/*
 * <pewna-cookie-banner> — centered cookie consent modal.
 *
 * Stores consent in localStorage (so banner doesn't re-trigger on every
 * pageview). Also calls Shopify.customerPrivacy API so analytics/marketing
 * flags are properly registered downstream (Klaviyo, Meta Pixel, GA4).
 */
class PewnaCookieBanner extends HTMLElement {
  constructor() {
    super();
    this.STORAGE_KEY = 'pewna_cookie_consent';
    this.handleAcceptAll = this.handleAcceptAll.bind(this);
    this.handleReject    = this.handleReject.bind(this);
  }

  connectedCallback() {
    const stored = this.readStored();

    if (!stored) {
      // First visit — show modal after a brief delay so it doesn't compete
      // with hero render.
      setTimeout(() => this.show(), 600);
    }

    this.querySelector('[data-cookie-accept-all]')?.addEventListener('click', this.handleAcceptAll);
    this.querySelector('[data-cookie-reject]')?.addEventListener('click', this.handleReject);
  }

  readStored() {
    try {
      const raw = window.localStorage?.getItem(this.STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  writeStored(level) {
    try {
      window.localStorage?.setItem(this.STORAGE_KEY, JSON.stringify({
        level,
        timestamp: Date.now(),
      }));
    } catch (e) { /* ignore */ }
  }

  show() {
    this.hidden = false;
    document.body.classList.add('pewna-cookie-open');
  }

  hide() {
    this.hidden = true;
    document.body.classList.remove('pewna-cookie-open');
  }

  setShopifyConsent(level) {
    if (!window.Shopify?.customerPrivacy) return;

    const flag = level === 'all';
    try {
      window.Shopify.customerPrivacy.setTrackingConsent({
        analytics: flag,
        marketing: flag,
        preferences: flag,
        sale_of_data: flag,
      }, () => {});
    } catch (e) { /* ignore */ }
  }

  handleAcceptAll() {
    this.writeStored('all');
    this.setShopifyConsent('all');
    this.hide();
  }

  handleReject() {
    this.writeStored('necessary');
    this.setShopifyConsent('necessary');
    this.hide();
  }
}

customElements.define('pewna-cookie-banner', PewnaCookieBanner);
